import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';

import RouterLink from 'src/components/ui/RouterLink';

const MainBreadcrumbs = (props) => {
	const { links = [] } = props;

	return (
		<Breadcrumbs aria-label="breadcrumb">
			{links.map((l, i) => {
				const isLast = i === links.length - 1;

				if (isLast) {
					return (
						<Link
							key={l.id}
							component={RouterLink}
							underline={l.href ? 'hover' : 'none'}
							color="text.primary"
							to={l.href}
							aria-current="page"
							{...l.link}
						>
							{l.label}
						</Link>
					);
				}
				return (
					<Link
						component={RouterLink}
						key={l.id}
						underline={l.href ? 'hover' : 'none'}
						color="inherit"
						to={l.href}
						{...l.link}
					>
						{l.label}
					</Link>
				);
			})}
		</Breadcrumbs>
	);
};

MainBreadcrumbs.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			label: PropTypes.string,
			href: PropTypes.string,
			link: PropTypes.shape(Link.propTypes),
		}),
	),
};

export default MainBreadcrumbs;
